import { travelGuideQueryKeys as e } from "./travelGuideQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { travelGuidesApi as r } from "@maat/api-main";
//#region src/travelGuides/useGuideSectionMutations.ts
var i = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.createSection(i, e),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, a = (i) => {
	let a = n();
	return t({
		mutationFn: ({ sectionId: e, data: t }) => r.updateSection(i, e, t),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, o = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.deleteSection(i, e),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
}, s = (i) => {
	let a = n();
	return t({
		mutationFn: (e) => r.reorderSections(i, e),
		onSuccess: () => a.invalidateQueries({ queryKey: e.detail(i) })
	});
};
//#endregion
export { i as useCreateGuideSectionMutation, o as useDeleteGuideSectionMutation, s as useReorderGuideSectionsMutation, a as useUpdateGuideSectionMutation };
